var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-play-wrap",on:{"click":function($event){$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.hideVideo($event)}}},[_c('div',{staticClass:"prism-player",attrs:{"id":"J_prismPlayer"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d8fc7d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/VideoPlay.vue
// module id = null
// module chunks = 